/** `/code` — resolves a short join code to an invite token, then hands off to `/join/:inviteToken`. */
import { useState, type FormEvent } from 'react';
import { ApiError, resolveShortCode } from '../api.ts';
import { useNavigate } from '../shell/router.tsx';
import { strings } from '../shell/strings.ts';

export function CodeEntry() {
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      const info = await resolveShortCode(code.trim());
      navigate(`/join/${info.inviteToken}`);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : strings.code.notFound);
      setSubmitting(false);
    }
  }

  return (
    <div className="page stack">
      <h1>{strings.code.title}</h1>
      <form className="stack" onSubmit={submit}>
        <div className="field">
          <label htmlFor="room-code">{strings.code.codeLabel}</label>
          <input
            id="room-code"
            type="text"
            required
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            placeholder={strings.code.codePlaceholder}
            maxLength={6}
          />
        </div>
        {error ? (
          <p className="badge badge-danger" role="alert">
            {error}
          </p>
        ) : null}
        <button type="submit" className="button button-primary" disabled={submitting || code.trim().length === 0}>
          {submitting ? strings.code.submitting : strings.code.submit}
        </button>
      </form>
      <footer className="footer">{strings.footer.conceptPrototype}</footer>
    </div>
  );
}
